import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "awd",
  "use": "awd-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 21 21\" id=\"awd\"><path fill=\"currentColor\" d=\"M4.5 2.56h3v5h-3zM13.5 2.56h3v5h-3zM4.5 13.56h3v5h-3zM13.5 13.56h3v5h-3z\" /><path stroke=\"currentColor\" stroke-width=\".8\" d=\"M7.5 5.06h6M7.5 16.06h6\" /><path stroke=\"currentColor\" stroke-width=\".8\" d=\"M10.5 5.06v11\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol